import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "numberOfLoans", "table"];

  removedRows = [];
  connect() {
    this.renderRows();
  }

  renderRows() {
    const numberOfRows = this.numberOfLoansTarget.value;
    const currentRows = this.rowsTarget.querySelectorAll('tr').length;

    if (numberOfRows > currentRows) {
      for (let i = currentRows; i < numberOfRows; i++) {
        this.addRow();
      }
    } else if (numberOfRows < currentRows) {
      for (let i = currentRows; i > numberOfRows; i--) {
        this.removeRow();
      }
    }

    this.tableTarget.style.display = numberOfRows > 0 ? '' : 'none';

  }

  addRow() {
    if (this.removedRows.length > 0) {
      const row = this.removedRows.pop();
      this.rowsTarget.appendChild(row);
    } else {
      this.addRowFromTemplate();
    }
  }

  addRowFromTemplate() {
    const newRow = document.createElement("tr");
    newRow.innerHTML = `
      <td><input class="input" type="text" name="business_loans[][creditor__c]" value=""></td>
      <td><div class="field"><p class="control has-icons-left"><input type="number" name="business_loans[][amount__c]" id="business_loans__amount__c" value="" class="input" min="0"><span class="icon is-small is-left"><box-icon name="euro"></box-icon></span></p></div>
      </td><td><div class="field"><p class="control has-icons-left"><input type="number" name="business_loans[][residualDebt__c]" id="business_loans__residualDebt__c" value="" class="input" min="0"><span class="icon is-small is-left"><box-icon name="euro"></box-icon></span></p></div>
      </td><td><div class="field"><p class="control has-icons-left"><input type="number" name="business_loans[][monthlyRepayment__c]" id="business_loans__monthlyRepayment__c" value="" class="input" min="0"><span class="icon is-small is-left"><box-icon name="euro"></box-icon></span></p></div>
      </td><td><input class="input" type="text" name="business_loans[][description__c]" value=""></td>
      <td><input class="input" type="date" name="business_loans[][endDate__c]" value=""></td>
    `;
    this.rowsTarget.appendChild(newRow);
  }

  removeRow() {
    const lastRow = this.rowsTarget.querySelector('tr:last-child');
    if (lastRow) {
      this.removedRows.push(lastRow);
      this.rowsTarget.removeChild(lastRow);
    }
  }

  numberOfLoansChanged() {
    this.renderRows();
  }
}
